const Notes = (props) => {
  const { notes } = props;
  if (!notes) {
    return null;
  }
  return (
    <span>
      <strong>Notes and dietary restrictions</strong>
      <br />
      {notes}
    </span>
  );
};

export default Notes;
